// ÐÑÐ¾Ð´Ð°Ð²ÐµÑ Ð¿Ð¾ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÑ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ: ÐºÐ»Ð¸ÐµÐ½Ñ CRM Ð¸Ð»Ð¸ (Ñ ÑÐµÑÑÑ Ð´Ð¸Ð»ÐµÑÐ¾Ð²) ÑÐ°Ð¼ ÐÐ¦.
// ÐÑÐº Ð¾ÑÐ´Ð°ÑÑ Ð¸Ñ Ð² ÑÐ°Ð·Ð½ÑÑ Ð¿Ð¾Ð»ÑÑ â consignment.seller Ð¸ consignment.sellerDc.

export const consignmentSellerOf = (consignment) =>
  consignment?.seller || (consignment?.sellerDc ? { ...consignment.sellerDc, isDc: true } : null);

export const sellerOptionOf = (seller) => {
  if (!seller) return null;
  if (seller.isDc) {
    return { value: seller.id, label: `${seller.name || ''}${seller.bin ? ` (ÐÐÐ: ${seller.bin})` : ''}`.trim() };
  }
  return {
    value: seller.id,
    label: `${seller.surname || ''} ${seller.name || ''}`.trim() + (seller.iin ? ` (ÐÐÐ: ${seller.iin})` : ''),
  };
};
